
// Countries configuration
export const COUNTRIES = [
  { value: 'NZ', label: 'New Zealand' },
  { value: 'AU', label: 'Australia' },
  { value: 'US', label: 'United States' },
];

// New Zealand Regions
export const NZ_REGIONS = [
  { value: 'AUK', label: 'Auckland' },
  { value: 'BOP', label: 'Bay of Plenty' },
  { value: 'CAN', label: 'Canterbury' },
  { value: 'GIS', label: 'Gisborne' },
  { value: 'HKB', label: "Hawke's Bay" },
  { value: 'MWT', label: 'Manawatu-Wanganui' },
  { value: 'MBH', label: 'Marlborough' },
  { value: 'NSN', label: 'Nelson' },
  { value: 'NTL', label: 'Northland' },
  { value: 'OTA', label: 'Otago' },
  { value: 'STL', label: 'Southland' },
  { value: 'TKI', label: 'Taranaki' },
  { value: 'TAS', label: 'Tasman' },
  { value: 'WKO', label: 'Waikato' },
  { value: 'WGN', label: 'Wellington' },
  { value: 'WTC', label: 'West Coast' },
];

// Australian States/Territories
export const AU_STATES = [
  { value: 'ACT', label: 'Australian Capital Territory' },
  { value: 'NSW', label: 'New South Wales' },
  { value: 'NT', label: 'Northern Territory' },
  { value: 'QLD', label: 'Queensland' },
  { value: 'SA', label: 'South Australia' },
  { value: 'TAS', label: 'Tasmania' },
  { value: 'VIC', label: 'Victoria' },
  { value: 'WA', label: 'Western Australia' },
];

// US States
export const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

// Country-specific labels
export const COUNTRY_CONFIG = {
  NZ: {
    stateLabel: 'Region',
    postalCodeLabel: 'Postal Code',
    regions: NZ_REGIONS,
    phoneCountry: 'NZ',
  },
  AU: {
    stateLabel: 'State',
    postalCodeLabel: 'Postcode',
    regions: AU_STATES,
    phoneCountry: 'AU',
  },
  US: {
    stateLabel: 'State',
    postalCodeLabel: 'ZIP Code',
    regions: US_STATES,
    phoneCountry: 'US',
  },
};

// Helper functions
export const getRegionsForCountry = (countryCode) => {
  return COUNTRY_CONFIG[countryCode]?.regions || [];
};

// Default config when no country is selected
const DEFAULT_CONFIG = {
  stateLabel: 'State/Region',
  postalCodeLabel: 'Postal/ZIP Code',
  regions: [],
  phoneCountry: 'NZ',
};

export const getCountryConfig = (countryCode) => {
  if (!countryCode) return DEFAULT_CONFIG;
  return COUNTRY_CONFIG[countryCode] || DEFAULT_CONFIG;
};

export const getCountry = (countryCode) => {
  return COUNTRIES.find(c => c.value === countryCode);
};

export const getRegion = (countryCode, regionValue) => {
  const regions = getRegionsForCountry(countryCode);
  return regions.find(r => r.value === regionValue);
};

// Legacy export for backward compatibility
export const REGIONS = NZ_REGIONS;

// Shared styles for country/region Select dropdowns to ensure proper colors
export const SELECT_STYLES = {
  control: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#45B79F' : state.isFocused ? '#e6f7f4' : '#ffffff',
    color: '#333333',
    cursor: 'pointer',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#333333',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#6c757d',
  }),
};
